import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { ExpenseReport_ExpenseReportStatus, Maybe } from '@/modules/__generated__/graphql/switchboard-generated';
import { AvatarWithIcon } from '../avatar-icon';
import { BudgetStatementsStatus } from '../budget-statements-status/budget-statements-status';
interface ContributorProfileInfoProps {
  name: string;
  code?: Maybe<string>;
  isCoreUnit: boolean;
  icon?: boolean;
  logoUrl?: Maybe<string>;
  status?: Maybe<ExpenseReport_ExpenseReportStatus>;
  className?: string;
}
function ContributorProfileInfo(t0) {
  const $ = _c(25);
  const {
    name,
    code,
    isCoreUnit,
    icon: t1,
    logoUrl,
    status,
    className
  } = t0;
  const icon = t1 === undefined ? true : t1;
  const hasLogo = logoUrl != null && logoUrl.trim() !== "";
  let t2;
  if ($[0] !== name) {
    t2 = name.charAt(0).toUpperCase() || "?";
    $[0] = name;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const fallbackText = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("flex min-w-0 items-center gap-2 md:flex-nowrap md:items-center", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = hasLogo ? logoUrl : undefined;
  let t5;
  if ($[4] !== fallbackText || $[5] !== icon || $[6] !== isCoreUnit || $[7] !== t4) {
    t5 = <AvatarWithIcon image={t4} fallbackText={fallbackText} icon={icon} isCoreUnit={isCoreUnit} />;
    $[4] = fallbackText;
    $[5] = icon;
    $[6] = isCoreUnit;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== code) {
    t6 = <div className="text-foreground/30 shrink-0 text-sm/5.5 font-semibold">{code}</div>;
    $[9] = code;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== name) {
    t7 = <div className="truncate text-sm/5.5 font-semibold">{name}</div>;
    $[11] = name;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex-start md:flex-center flex min-w-0 gap-2 md:w-50">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = status as ExpenseReport_ExpenseReportStatus;
  let t10;
  if ($[16] !== t9) {
    t10 = <div className="flex md:hidden"><BudgetStatementsStatus status={t9} /></div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <div className="flex min-w-0 flex-col gap-1">{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t3 || $[23] !== t5) {
    t12 = <div className={t3}>{t5}{t11}</div>;
    $[21] = t11;
    $[22] = t3;
    $[23] = t5;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
export { ContributorProfileInfo };